import { render, staticRenderFns } from "./CreateFolder.vue?vue&type=template&id=5c600d5e&"
import script from "./CreateFolder.vue?vue&type=script&lang=js&"
export * from "./CreateFolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports